/**
 * App configuration.
 *
 * The brand subdomain is resolved from the URL at runtime: when served from
 * `<brand>.onlineordering.getsonic.co`, `<brand>` is used as the
 * `X-Brand-Subdomain` header. On localhost (no subdomain) the app falls back to
 * `brandSubdomain` below, so set that to the tenant you develop against.
 */
/** Backend API host — called directly (the API must allow CORS from the app origin). */
const API_HOST = 'https://api-onlineordering.getsonic.co';

export const environment = {
  production: false,
  /** Call the API directly everywhere (dev + deploy) — no dev-server proxy. */
  apiBase: API_HOST,
  /** Base host for tenant subdomains. `<brand>.<brandBaseDomain>` → brand = `<brand>`. */
  brandBaseDomain: 'onlineordering.getsonic.co',
  /** Fallback brand used when no subdomain is present in the URL (e.g. localhost). */
  brandSubdomain: 'bittersweet',
  /** Static test OTP for this tenant, shown as a tap-to-fill hint. Set to '' to hide (production). */
  demoOtp: '121212',
  /**
   * FALLBACK admin origins allowed to embed this storefront as a live preview, used only when the
   * brand config has no `adminOrigin` (which, when present, must match exactly). Exact patterns,
   * never a wildcard origin: tenant admin hosts + local admin dev servers.
   */
  previewParentOrigins: [
    /^https:\/\/[a-z0-9-]+\.admin\.getsonic\.co$/,
    // Local admin dev servers, incl. tenant subdomains (bittersweet.localhost:8006).
    /^http:\/\/(([a-z0-9-]+\.)?localhost|127\.0\.0\.1|([a-z0-9-]+\.)?sonic\.test)(:\d+)?$/,
  ] as RegExp[],
};
